import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import api from "../../../../../services/api";
import HeaderSession from "../../../../../utils/headerSession";
import { useDispatch, useSelector } from "react-redux";
import ListaSolicitacao from "../listaSolicitacao";
import RegisterAccess from "../../../../../utils/registerAccess";
import { SolicitacoesLicenciamentoExcel } from "../../../../exports/gerarelatorioexcel";
import { SolicitacaoLicenciamentoPdf } from "../../../../exports/gerarelatoriopdf";
import { IconButton, Menu, MenuItem, ListItemIcon, Tooltip, Box } from "@mui/material";
import { Download } from "@mui/icons-material";
import DownloadIcon from "@mui/icons-material/Download";
import { temPermissao } from "../../../../../utils/permissoes";
import HeaderGestorConfigs from "../../../../../utils/headerGestorConfigs";
import TabelaLoading from "../../../../../load/tabelaLoading";
import Paginacao from "../../../../../utils/paginacao";

export default function AnaliseInspeccao() {
  const user = useSelector((state) => state.account.user);
  const navigate = useNavigate();
  const [tipo, setTipo] = useState('');
  // const [status, setStatus] = useState(''); // novo estado para filtro de status
  const [provincia, setProvincia] = useState('');
  const [estabelecimentosInspeccionados, setEstabelecimentosInspeccionados] = useState("");
  const [estabelecimentosInspeccaoReprovada, setEstabelecimentosInspeccaoReprovada,] = useState("");
  const [perPage, setPerPage] = useState(50);
  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();
  const [page, setPage] = useState(searchParams.get("page"));
  const [dataInicio, setDataInicio] = useState("");
  const [dataFim, setDataFim] = useState("");
  const [ConfigLista1, setConfigLista1] = useState("");
  const [ConfigLista2, setConfigLista2] = useState("");


  useEffect(() => {
    if (temPermissao(user, ['licenciamentoEstabelecimentoInspeccaoRealizada'])) {
    } else {

      dispatch({
        type: "alert",
        payload: { alert: "Acesso negado" },
      });
      navigate("/admin/menu");
    }

    // APLICAR DESTE JEITO FUTURAMENTE PARA OTIMIZAR O TEMPO DE CARREGAMENTO DAS DUAS LISTAS, POIS AS REQUISIÇÕES VÃO SER FEITAS EM PARALELO
    // const [
    //   inspeccaoRealizadaResponse,
    //   inspeccaoReprovadaResponse,
    // ] = await  Promise.all([
    //   api.get(`/estabelecimentos?page=${page}&status=Inspecção Realizada&perPage=${perPage}}&status=${status}&dataInicio=${dataInicio}&dataFim=${dataFim}&provincia=${provincia}&tipoId=${tipo}`),
    //   api.get(`/estabelecimentos?page=${page}&statusInspeccao=Reprovada&perPage=${perPage}}&status=${status}&dataInicio=${dataInicio}&dataFim=${dataFim}&provincia=${provincia}&tipoId=${tipo}`)
    // ]);
    // setEstabelecimentosInspeccionados(inspeccaoRealizadaResponse.response.data.estabelecimentos);
    // setEstabelecimentosInspeccaoReprovada(inspeccaoReprovadaResponse.response.data.estabelecimentos);


    api.get(`/estabelecimentos?page=${page}&status=Inspecção Realizada&perPage=${perPage}&dataInicio=${dataInicio}&dataFim=${dataFim}&provincia=${provincia}&tipoId=${tipo}`)
      .then((response) => {
        setEstabelecimentosInspeccionados(response.data.estabelecimentos);
        setConfigLista1(response.data);
      }).catch((err) => "");

    api.get(`/estabelecimentos?page=${page}&statusInspeccao=Reprovada&perPage=${perPage}&dataInicio=${dataInicio}&dataFim=${dataFim}&provincia=${provincia}&tipoId=${tipo}`)
      .then((response) => {
        setEstabelecimentosInspeccaoReprovada(response.data.estabelecimentos);
        setConfigLista2(response.data);
      })
      .catch((err) => "");
  }, [
    page,
    perPage,
    user?.funcao,
    tipo,
    provincia,
    user?.seccao,
    navigate,
    dispatch,
    dataInicio,
    dataFim
  ]);

  const [anchorEl, setAnchorEl] = useState(null);
  const Expports = ({ estabelecimentos }) => {
    return (
      <Box sx={{ position: 'absolute', right: 0, top: -10 }}>
        <Tooltip title="Opções para Baixar">
          <IconButton onClick={(e) => setAnchorEl(e.currentTarget)}>
            <Download />
          </IconButton>
        </Tooltip>

        <Menu
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={() => setAnchorEl(null)}
        >
          <MenuItem
            onClick={() => SolicitacoesLicenciamentoExcel(estabelecimentos)}
          >
            <ListItemIcon>
              <DownloadIcon color="secondary" />
            </ListItemIcon>
            Baixar Excel
          </MenuItem>
          <MenuItem
            onClick={() => SolicitacaoLicenciamentoPdf(estabelecimentos)}
          >
            <ListItemIcon>
              <DownloadIcon color="secondary" />
            </ListItemIcon>
            Baixar PDF
          </MenuItem>
        </Menu>
      </Box>
    );
  };

  return (
    <>
      <RegisterAccess page={"area de chefe de departamento"} />

      <HeaderSession title="PROCESSOS PARA ANALISE DE INSPECCÃO" />

      {estabelecimentosInspeccionados ? (
        <Box position={'relative'}>
          <Expports estabelecimentos={estabelecimentosInspeccionados} />

          <HeaderGestorConfigs title={' ESTABELECIMENTOS JÁ INSPECCIONADOS'} />
          <ListaSolicitacao
            estabelecimentos={estabelecimentosInspeccionados}
            setEstabelecimentos={setEstabelecimentosInspeccionados}
            tipo={tipo}
            setTipo={setTipo}
            provincia={provincia}
            setProvincia={setProvincia}
            setDataInicio={setDataInicio}
            setDataFim={setDataFim}
            dataInicio={dataInicio}
            dataFim={dataFim}
          >
            <Paginacao
              lista={estabelecimentosInspeccionados}
              configLista={ConfigLista1}
              page={page}
              perPage={perPage}
              setPage={setPage}
              setPerPage={setPerPage}
            />
          </ListaSolicitacao>
        </Box>
      )
        :
        <TabelaLoading />
      }

      <br />
      <br />
      {estabelecimentosInspeccaoReprovada && (
        <Box position={'relative'}>
          <Expports estabelecimentos={estabelecimentosInspeccaoReprovada} />
          <HeaderGestorConfigs title={'INSPECCŌES REPROVADAS'} />
          <ListaSolicitacao
            estabelecimentos={estabelecimentosInspeccaoReprovada}
            setEstabelecimentos={setEstabelecimentosInspeccaoReprovada}
            tipo={tipo}
            setTipo={setTipo}
            provincia={provincia}
            setProvincia={setProvincia}
            setDataInicio={setDataInicio}
            setDataFim={setDataFim}
            dataInicio={dataInicio}
            dataFim={dataFim}
          >
            <Paginacao
              lista={estabelecimentosInspeccaoReprovada}
              configLista={ConfigLista2}
              page={page}
              perPage={perPage}
              setPage={setPage}
              setPerPage={setPerPage}
            />
          </ListaSolicitacao>
        </Box>
      )}
    </>
  );
}
